import { RouteComponentProps, useLocation } from 'react-router'
import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '../../../provider/StoreProvider'

type Props = RouteComponentProps<{
  provider: 'google' | 'kakao' | 'naver'
}>

export const SignInVerify: React.FC<Props> = observer(({ history, match }) => {
  const { authStore } = useContext(StoresContext)
  const location = useLocation()
  const params: string = location.search

  const provider = ['kakao', 'google', 'naver']

  useEffect(() => {
    if (!provider.includes(match.params.provider)) {
      history.push('/home')
      return
    }
    authStore.oAuthVerify(match.params.provider, params, history.push)
  }, [])

  return <></>
})
